import { render } from "./TravelPass.vue?vue&type=template&id=3a4b46ff"
const script = {}
script.render = render

export default script